import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface Props {
	text: string;
	onSuccess: () => void;
	onCancel: () => void;
}

export function Confirm(props: Props) {
	const { text, onSuccess, onCancel } = props;

	return (
		<Modal show onHide={onCancel} backdrop='static' keyboard={false}>
			<Modal.Body>{text}</Modal.Body>
			<Modal.Footer>
				<Button variant='secondary' onClick={onCancel}>
					Chiudi
				</Button>
				<Button variant='primary' onClick={onSuccess}>
					Prosegui
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
export default Confirm;
